/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the ScheduleSplitCommunication provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ScheduleSplitCommunication {

  constructor(public http: Http) {
    // console.log('Hello ScheduleSplitCommunication Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/schedule-split-communication.ts